/**
 * 403 Forbidden Page
 * 
 * Shown when user tries to access a section they don't have permission for.
 */

import { useNavigate } from "react-router-dom";
import { Shield, ArrowLeft } from "lucide-react";

const Forbidden403 = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="mb-6 flex justify-center">
          <div className="p-4 bg-red-100 rounded-full">
            <Shield className="text-red-600" size={48} />
          </div>
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-2">403</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Access Denied</h2>
        
        <p className="text-gray-600 mb-8">
          You don't have permission to access this section. Please contact your administrator if you believe this is an error.
        </p>
        
        <button
          onClick={() => navigate("/dashboard")}
          className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-gray-900 text-white rounded-xl font-semibold hover:bg-gray-800 transition-colors"
        >
          <ArrowLeft size={20} />
          <span>Go to Dashboard</span>
        </button>
      </div>
    </div>
  );
};

export default Forbidden403;
